export function navFixed() {
  // 页面滚动条滚动的高度
  let scrollTop =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop;

  if (scrollTop >= 150) {
    // 触发的位置
    document.getElementById("header").style.cssText =
      "position:fixed;height:86px;background:#262b4f;";
    document.getElementsByClassName("nav-list")[0].style.cssText =
      "position:fixed;";
  } else {
    document.getElementById("header").style.cssText =
      "position:absolute;height:auto;background:none;";
    document.getElementsByClassName("nav-list")[0].style.cssText =
      "position:absolute;";
  }
}

export function resize() {
  let width = window.innerWidth;
  let height = window.innerHeight;
  let body = document.getElementsByTagName("body")[0];
  if (width >= 1920) {
    body.style.width = width;
    body.style.height = height;
  } else {
    body.style.width = 1920 + "px";
    body.style.height = 969 + "px";
    var ratiox = width / 1920; //当前的宽度比就是   电脑的宽度比1920  显示缩小的比例
    var ratioy = height / 969;
    body.style.transform = `scale(${ratio},${ratioy})`;
    body.style.transformOrigin = "left top";
    body.style.backgroundSize = "100%";
  }
}
